var map = {
	"./phone_width_product_option_bubbles": [
		28522,
		8522
	],
	"./phone_width_product_option_bubbles.json": [
		28522,
		8522
	],
	"./phone_width_sparkles": [
		50140,
		140
	],
	"./phone_width_sparkles.json": [
		50140,
		140
	],
	"./store_loading": [
		95511,
		5511
	],
	"./store_loading.json": [
		95511,
		5511
	],
	"./store_stanley_building": [
		31594,
		1594
	],
	"./store_stanley_building.json": [
		31594,
		1594
	],
	"./welcome-stanley-rocket": [
		75289,
		5289
	],
	"./welcome-stanley-rocket.json": [
		75289,
		5289
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69238;
module.exports = webpackAsyncContext;